import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getProfile,
  updateProfile,
  updateProfileImage,
  startFaydaVerification,
} from "../../features/authSlice";
import { loadBanks } from "../../features/bidSlice";
import { setLanguage } from "../../features/languageSlice";
import { user_man, user_woman } from "../../assets";
import translate from "../../Services/translate";
import Loading from "../common/Loading";
import Modal from "../common/Modal";
import ResponseModal from "../common/ResponseModal";
import toast from "react-hot-toast";

const MyAccount = () => {
  const dispatch = useDispatch();

  // eslint-disable-next-line
  const { language } = useSelector(({ language }) => language);
  const { auth_loading, myProfile, profile_loading, update_loading } =
    useSelector(({ auth }) => auth);
  const { banks, my_subscriptions } = useSelector(({ bid }) => bid);
  const { myFaydaStatus } = useSelector(({ auth }) => auth);

  console.log("myProfile", myFaydaStatus);
  const [profile, setProfile] = useState({ user_profile: {}, bank_info: {} });
  const [imagePreview, setImagePreview] = useState("");
  // const [tempPhone, setTempPhone] = useState();
  console.log("profile", profile);

  useEffect(() => {
    dispatch(loadBanks());
    if (!Object.keys(myProfile).length) dispatch(getProfile());
    // eslint-disable-next-line
  }, []);

  const updateMyProfile = () => {
    dispatch(updateProfile(profile));
  };
  const startVerification = () => {
    dispatch(startFaydaVerification()).then((response) => {
      console.log("response", response);
      if (response.payload.authorization_url) {
        window.location.href = response.payload.authorization_url;
      }
    });
  };

  const uploadPicture = () => {
    const MAX_SIZE = 2 * 1024 * 1024; // 2MB in bytes

    var input = document.createElement("input");
    input.type = "file";
    input.accept = ".jpg, .jpeg, .png";

    input.onchange = (e) => {
      const file = e.target.files?.[0];

      if (file) {
        if (file.size > MAX_SIZE) {
          toast.error(translate(353), { duration: 2000 });

          return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
          setImagePreview(e.target.result);
        };
        reader.readAsDataURL(file);

        dispatch(updateProfileImage({ image: file })).then(() => {
          setProfile((prev) => ({
            ...prev,
            user_profile: {
              ...prev.user_profile,
              image_url: myProfile.img_url,
            },
          }));
        });
      }
    };

    input.click();
  };

  // const modifyPhone = num => {
  //   // num?.length && setTempPhone(num[0])
  //   if(num?.length === 10){
  //       if(num[0] == 0){
  //           return '+251' + num.slice(1)
  //       }
  //   }else if(num?.length === 9){
  //       if(num[0] == 9){
  //           return '+251' + num
  //       }
  //   }
  //   return null
  // }

  if (auth_loading)
    return (
      <div className="pt-12">
        <Loading loading={auth_loading} loadingStyle="text-sky-600 w-7 h-7" />
      </div>
    );

  return (
    <div className="pb-5 md:pb-12">
      <div className="self-center pb-1 text-primary-100 font-semibold text-left pl-10 border-b border-gray-300 py-1 flex justify-between">
        <h2 className="text-lg md:text-2xl font-Stencil">{translate(146)}</h2>
      </div>

      <div className="md:flex w-full p-3 ">
        <div className="w-full md:w-[20%] border-r border-gray-300 flex justify-center items-center">
          <div className="flex md:flex-col">
            <div
              className="h-20 md:h-80 w-14 md:w-52 rounded-[50%] max-h-[200px] max-w-[200px] relative border border-gray-300"
              onClick={() => uploadPicture()}
            >
              <img
                src={
                  imagePreview
                    ? imagePreview
                    : myProfile?.user_profile?.image_url
                      ? `${myProfile.user_profile.image_url}`
                      : myProfile?.user_profile?.gender === "FEMALE"
                        ? user_woman
                        : user_man
                }
                alt="user"
                className="h-full w-full max-h-[200px] max-w-[200px] rounded-[50%] object-contain cursor-pointer"
              />
              <div className="absolute top-[50%]  flex justify-center w-full">
                <Loading
                  loading={profile_loading}
                  loadingStyle="text-white w-7 h-7"
                />
              </div>
            </div>
            <div className="pl-5 md:pl-0">
              <p className="font-semibold md:text-lg text-center pt-2 text-gray-400">
                {myProfile?.user_profile?.first_name
                  ? myProfile.user_profile.first_name +
                    " " +
                    myProfile.user_profile.last_name
                  : ""}
              </p>
              <p className="font-semibold md:text-lg text-center text-gray-400">
                {myProfile?.user_profile?.email}
              </p>
            </div>
            <div className="flex justify-center py-4 hidden">
              {myFaydaStatus?.is_verified ? (
                /* Elegant Verified Badge */
                <div className="inline-flex items-center gap-2 rounded-full bg-green-50 px-4 py-2 text-sm font-semibold text-green-700 border border-green-200 shadow-sm animate-fade-in">
                  <svg
                    className="h-5 w-5 text-green-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2.5"
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                  <span>Fayda Verified</span>
                </div>
              ) : (
                /* Modernized Action Button */
                <button
                  onClick={() => startVerification()}
                  disabled={update_loading}
                  className={`inline-flex items-center justify-center px-5 py-2.5 text-sm font-semibold text-white rounded-full border border-transparent shadow-sm transition-all duration-200 
      ${
        update_loading
          ? "bg-secondary-400 cursor-not-allowed opacity-80"
          : "bg-secondary-50 hover:bg-sky-500 active:scale-98"
      } `}
                >
                  {update_loading ? (
                    <Loading
                      loading={update_loading}
                      loadingStyle="h-5 w-5 text-white animate-spin"
                    />
                  ) : (
                    "Verify my Fayda"
                  )}
                </button>
              )}
            </div>
          </div>
        </div>

        <div className="w-full md:w-[40%] border-r border-gray-300">
          <h2 className="text-center text-2xl font-bold py-3 text-gray-600">
            {translate(279)}
          </h2>

          <div className="flex w-full justify-between px-3 md:px-5 py-2 md:py-3">
            <div className="w-1/2 pr-1 md:pr-3">
              <label
                htmlFor="_first_name"
                className="block mb-1 text-[0.7rem] font-medium text-gray-500"
              >
                {translate(97)}
              </label>
              <input
                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded md:rounded-lg focus:outline-none focus:border-gray-500 block w-full p-1 md:p-2"
                defaultValue={myProfile?.user_profile?.first_name}
                value={profile.user_profile.first_name}
                onChange={(e) => {
                  const value = e.target.value.replace(/\s/g, "");

                  if (/^[a-zA-Z\u1200-\u137F]*$/.test(value)) {
                    setProfile({
                      ...profile,
                      user_profile: {
                        ...profile.user_profile,
                        first_name: value,
                      },
                    });
                  }
                }}
                type="text"
                id="_first_name"
                placeholder={translate(97)}
              />
            </div>
            <div className="w-1/2 pl-1 md:pl-3">
              <label
                htmlFor="_last_name"
                className="block mb-1 text-[0.7rem] font-medium text-gray-500"
              >
                {translate(99)}
              </label>
              <input
                className="block p-1 md:p-2 w-full text-sm text-gray-900 bg-gray-50 rounded md:rounded-lg border border-gray-300 shadow-sm focus:outline-none focus:border-gray-500"
                defaultValue={myProfile?.user_profile?.last_name}
                value={profile.user_profile.last_name}
                onChange={(e) => {
                  const value = e.target.value.replace(/\s/g, "");
                  if (/^[a-zA-Z\u1200-\u137F\s]*$/.test(value)) {
                    setProfile({
                      ...profile,
                      user_profile: {
                        ...profile.user_profile,
                        last_name: value,
                      },
                    });
                  }
                }}
                type="text"
                id="_last_name"
                placeholder={translate(99)}
              />
            </div>
          </div>
          <div className="w-full justify-between px-5 md:px-5 py-2 md:py-3 ">
            <label
              htmlFor="_legal_name"
              className="block mb-1 text-[0.7rem] font-medium text-gray-500"
            >
              {translate(355)}
            </label>
            <input
              className="block p-1 md:p-2 w-full text-sm text-gray-900 bg-gray-50 rounded md:rounded-lg border border-gray-300 shadow-sm focus:outline-none focus:border-gray-500"
              defaultValue={myProfile?.user_profile?.legal_name}
              value={profile.user_profile.legal_name}
              onChange={(e) => {
                const value = e.target.value;
                if (/^[a-zA-Z\u1200-\u137F\s]*$/.test(value)) {
                  setProfile({
                    ...profile,
                    user_profile: {
                      ...profile.user_profile,
                      legal_name: value,
                    },
                  });
                }
              }}
              type="text"
              id="_last_name"
              placeholder={translate(355)}
            />
          </div>

          <div className="flex w-full justify-between px-3 md:px-5 py-2 md:py-3">
            <div className="w-1/2 pr-1 md:pr-3">
              <label
                htmlFor="_email"
                className="block mb-1 text-[0.7rem] font-medium text-gray-500"
              >
                {translate(101)}
              </label>
              <input
                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded md:rounded-lg focus:outline-none focus:border-gray-500 block w-full p-1 md:p-2"
                defaultValue={myProfile?.user_profile?.email}
                onChange={(e) => {
                  const value = e.target.value.replace(/\s/g, ""); // remove all spaces
                  setProfile({
                    ...profile,
                    user_profile: {
                      ...profile.user_profile,
                      email: value,
                    },
                  });
                }}
                onKeyDown={(e) => {
                  if (e.key === " ") {
                    e.preventDefault(); // Block spacebar
                  }
                }}
                type="email"
                id="_email"
                placeholder={translate(101)}
              />
            </div>
            <div className="w-1/2 pl-1 md:pl-3">
              <label
                htmlFor="_phone"
                className="block mb-1 text-[0.7rem] font-medium text-gray-500"
              >
                {translate(103)}
              </label>
              <input
                className="block p-1 md:p-2 w-full text-sm text-gray-900 bg-gray-50 rounded md:rounded-lg border border-gray-300 shadow-sm focus:outline-none"
                defaultValue={myProfile?.user_profile?.phone_number}
                type="text"
                id="_phone"
                readOnly
              />
            </div>
          </div>

          <div className="flex w-full justify-between px-3 md:px-5 py-2 md:py-3">
            <div className="w-1/2 pr-1 md:pr-3">
              <label
                htmlFor="_country"
                className="block mb-1 text-[0.7rem] font-medium text-gray-500"
              >
                {translate(280)}
              </label>
              <input
                defaultValue={myProfile?.user_profile?.country}
                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded md:rounded-lg focus:outline-none block w-full p-1 md:p-2"
                type="text"
                id="_country"
                readOnly
              />
            </div>
            <div className="w-1/2 pl-1 md:pl-3">
              <label
                htmlFor="_region"
                className="block mb-1 text-[0.7rem] font-medium text-gray-500"
              >
                {translate(281)}{" "}
                {profile.user_profile?.address?.city &&
                !profile.user_profile?.address?.region ? (
                  <span className="text-red-600"> (Required)</span>
                ) : (
                  ""
                )}
              </label>
              <input
                className="block p-1 md:p-2 w-full text-sm text-gray-900 bg-gray-50 rounded md:rounded-lg border border-gray-300 shadow-sm focus:outline-none focus:border-gray-500"
                defaultValue={
                  myProfile?.user_profile?.address?.region
                    ? myProfile.user_profile?.address?.region
                    : ""
                }
                value={profile.user_profile?.address?.region || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^[a-zA-Z\u1200-\u137F\s]*$/.test(value)) {
                    setProfile({
                      ...profile,
                      user_profile: {
                        ...profile.user_profile,
                        address: {
                          ...profile.user_profile.address,
                          region: value,
                        },
                      },
                    });
                  }
                }}
                type="text"
                id="_region"
                placeholder={translate(281)}
              />
            </div>
          </div>

          <div className="flex w-full justify-between px-3 md:px-5 py-2 md:py-3">
            <div className="w-1/2 pr-1 md:pr-3">
              <label
                htmlFor="_city"
                className="block mb-1 text-[0.7rem] font-medium text-gray-500"
              >
                {translate(282)}
                {!profile.user_profile?.address?.city &&
                profile.user_profile?.address?.region ? (
                  <span className="text-red-600"> (Required)</span>
                ) : (
                  ""
                )}
              </label>
              <input
                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded md:rounded-lg focus:outline-none focus:border-gray-500 block w-full p-1 md:p-2"
                defaultValue={myProfile?.user_profile?.address?.city}
                value={
                  profile?.user_profile?.address?.city
                    ? profile?.user_profile?.address?.city
                    : ""
                }
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^[a-zA-Z\u1200-\u137F\s]*$/.test(value)) {
                    setProfile({
                      ...profile,
                      user_profile: {
                        ...profile.user_profile,
                        address: {
                          ...profile.user_profile.address,
                          city: value,
                        },
                      },
                    });
                  }
                }}
                type="text"
                id="_city"
                placeholder={translate(282)}
              />
            </div>
            <div className="w-1/2 pl-1 md:pl-3">
              <label
                htmlFor="_birth_date"
                className="block mb-1 text-[0.7rem] font-medium text-gray-500"
              >
                {translate(283)}
              </label>
              <input
                className="block p-1 md:p-2 w-full text-sm text-gray-900 bg-gray-50 rounded md:rounded-lg border border-gray-300 shadow-sm focus:outline-none focus:border-gray-500"
                defaultValue={
                  myProfile?.user_profile?.birth_date
                    ? myProfile.user_profile.birth_date
                    : ""
                }
                value={profile.user_profile.birth_date}
                onChange={(e) => {
                  const value = e.target.value;
                  const isRealDate = !isNaN(new Date(value).getTime());
                  const isValidDate =
                    /^\d{4}-(0[1-9]|1[0-2])-([0-2][0-9]|3[01])$/.test(value);

                  if (isValidDate && isRealDate) {
                    setProfile({
                      ...profile,
                      user_profile: {
                        ...profile.user_profile,
                        birth_date: value,
                      },
                    });
                  } else {
                  }
                }}
                // onChange = { e => setProfile({ ...profile, user_profile: { ...profile.user_profile, birth_date: e.target.value } }) }
                type="date"
                id="_birth_date"
              />
            </div>
          </div>

          <div className="flex w-full justify-between px-3 md:px-5 py-2 md:py-3">
            <div className="w-1/2 pr-1 md:pr-3">
              <label
                htmlFor="_gender"
                className="block mb-1 text-[0.7rem] font-medium text-gray-500"
              >
                {translate(284)}
              </label>
              <select
                className="block p-1 md:p-2 w-full text-sm text-gray-900 bg-gray-50 rounded md:rounded-lg border border-gray-300 shadow-sm focus:outline-none focus:border-gray-500"
                defaultValue={myProfile?.user_profile?.gender}
                onChange={(e) =>
                  setProfile({
                    ...profile,
                    user_profile: {
                      ...profile.user_profile,
                      gender: e.target.value,
                    },
                  })
                }
                id="_gender"
              >
                <option className="hidden font-thin text-blue-600 hover:text-blue-600">
                  {translate(284)}
                </option>
                <option value="MALE">{translate(285)}</option>
                <option value="FEMALE">{translate(286)}</option>
              </select>
            </div>
            <div className="w-1/2 pl-1 md:pl-3">
              <label
                htmlFor="_preferred_language"
                className="block mb-1 text-[0.7rem] font-medium text-gray-500"
              >
                {translate(116)}
              </label>
              <select
                className="focus:outline-none block p-1 md:p-2 w-full text-sm text-gray-900 bg-gray-50 rounded md:rounded-lg border border-gray-300 shadow-sm"
                defaultValue={myProfile?.user_profile?.preferred_language}
                onChange={(e) => {
                  setProfile({
                    ...profile,
                    user_profile: {
                      ...profile.user_profile,
                      preferred_language: e.target.value,
                    },
                  });
                  dispatch(setLanguage({ lang: e.target.value }));
                }}
                id="_preferred_language"
              >
                <option className="hidden font-thin text-blue-600 hover:text-blue-600">
                  {translate(116)}
                </option>
                <option name="English" value="English">
                  English
                </option>
                <option name="Amharic" value="Amharic">
                  አማርኛ
                </option>
                <option name="Afaan-Oromoo" value="Afaan-Oromoo">
                  Afaan-Oromoo
                </option>
              </select>
            </div>
          </div>
        </div>

        <div className="w-full md:w-[40%] ">
          <h2 className="text-center text-2xl font-bold py-3 text-gray-600">
            {translate(287)}
          </h2>

          <div className="flex w-full justify-between px-3 md:px-5 py-2 md:py-3">
            <div className="w-1/2 pr-1 md:pr-3">
              <label
                htmlFor="_bank"
                className="block mb-1 text-[0.7rem] font-medium text-gray-500"
              >
                {translate(189)}
              </label>
              <select
                className="focus:outline-none block p-1 md:p-2 w-full text-sm text-gray-900 bg-gray-50 rounded md:rounded-lg border border-gray-300 shadow-sm"
                defaultValue={myProfile?.bank_info?.bank}
                onChange={(e) =>
                  setProfile({
                    ...profile,
                    bank_info: { ...profile.bank_info, bank: e.target.value },
                  })
                }
                id="_bank"
              >
                <option className="hidden font-thin text-gray-600">
                  {translate(190)}
                </option>
                {banks.map((b, i) => (
                  <option key={i} value={b.id}>
                    {b.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="w-1/2 pl-1 md:pl-3">
              <label
                htmlFor="_account_holder_name"
                className="block mb-1 text-[0.7rem] font-medium text-gray-500"
              >
                {translate(288)}
                {profile.bank_info.account_number &&
                !profile.bank_info.account_holder_name ? (
                  <span className="text-red-600"> (Required)</span>
                ) : (
                  ""
                )}
              </label>
              <input
                className="block p-1 md:p-2 w-full text-sm text-gray-900 bg-gray-50 rounded md:rounded-lg border border-gray-300 shadow-sm focus:outline-none focus:border-gray-500"
                defaultValue={myProfile?.bank_info?.account_holder_name}
                value={profile.bank_info.account_holder_name}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^[a-zA-Z\u1200-\u137F\s]*$/.test(value)) {
                    setProfile({
                      ...profile,
                      bank_info: {
                        ...profile.bank_info,
                        account_holder_name: value,
                      },
                    });
                  }
                }}
                // onChange = { e => setProfile({ ...profile, bank_info: { ...profile.bank_info, account_holder_name: e.target.value } }) }
                type="text"
                id="_account_holder_name"
                placeholder={translate(288)}
              />
            </div>
          </div>

          <div className="flex w-full justify-between px-3 md:px-5 py-2 md:py-3">
            <div className="w-1/2 pr-1 md:pr-3">
              <label
                htmlFor="_account_number"
                className="block mb-1 text-[0.7rem] font-medium text-gray-500"
              >
                {translate(289)}{" "}
                {!profile.bank_info.account_number &&
                profile.bank_info.account_holder_name ? (
                  <span className="text-red-600"> (Required)</span>
                ) : (
                  ""
                )}
              </label>
              <input
                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded md:rounded-lg focus:outline-none focus:border-gray-500 block w-full p-1 md:p-2"
                defaultValue={myProfile?.bank_info?.account_number}
                value={profile.bank_info.account_number}
                onChange={(e) =>
                  setProfile({
                    ...profile,
                    bank_info: {
                      ...profile.bank_info,
                      account_number: e.target.value,
                    },
                  })
                }
                type="number"
                id="_account_number"
                placeholder={translate(289)}
              />
            </div>
            <div className="w-1/2 pl-1 md:pl-3">
              <label
                htmlFor="_account_type"
                className="block mb-1 text-[0.7rem] font-medium text-gray-500"
              >
                {translate(290)}
              </label>
              <select
                className="focus:outline-none block p-1 md:p-2 w-full text-sm text-gray-900 bg-gray-50 rounded md:rounded-lg border border-gray-300 shadow-sm"
                defaultValue={myProfile?.bank_info?.account_type}
                onChange={(e) =>
                  setProfile({
                    ...profile,
                    bank_info: {
                      ...profile.bank_info,
                      account_type: e.target.value,
                    },
                  })
                }
                id="_account_type"
              >
                <option className="hidden font-thin text-blue-600 hover:text-blue-600">
                  {translate(291)}
                </option>
                <option value="SAVING">SAVING</option>
              </select>
            </div>
          </div>

          <h2 className="text-center text-2xl font-bold pt-6 text-gray-600">
            {translate(292)}
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 w-full px-3 md:px-5 pt-6">
            {my_subscriptions.map((s, i) => (
              <div
                key={i}
                className="rounded-xl py-2 px-3 bg-gradient-to-r from-sky-700 to-gray-900 text-white hover:scale-105 duration-200"
              >
                <div className="flex justify-between">
                  <p className="text-sm">{translate(294)}:</p>
                  <p className="text-sm">{s?.package?.name}</p>
                </div>

                <div className="flex justify-between">
                  <p className="text-sm">{translate(295)}:</p>
                  <p className="text-sm">{s?.package?.price}</p>
                </div>
                <div className="flex justify-between">
                  <p className="text-sm">{translate(296)}:</p>
                  <p className="text-sm">{s?.start_date}</p>
                </div>
                <div className="flex justify-between">
                  <p className="text-sm">{translate(297)}:</p>
                  <p className="text-sm">{s?.end_date}</p>
                </div>
                <div className="flex justify-between">
                  <p className="text-sm">{translate(245)}:</p>
                  <p className="text-sm text-green-400">
                    {s?.is_active ? translate(8) : translate(9)}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="flex justify-center md:flex-row-reverse md:justify-start pt-2 md:pt-4">
        <div className="flex justify-center w-full md:w-[80%]">
          <button
            onClick={() => updateMyProfile()}
            className="bg-secondary-50 hover:bg-sky-500 w-72 text-white rounded-full border drop-shadow py-2"
          >
            {update_loading ? (
              <Loading
                loading={update_loading}
                loadingStyle="h-6 w-6 text-white"
              />
            ) : (
              translate(293)
            )}
          </button>
        </div>
      </div>

      {/* <ResponseModal></ResponseModal> */}
    </div>
  );
};

export default MyAccount;
